export const OVERFLOW_PADDING = 20;
